import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSiteAuth } from '../hooks/useSiteAuth';

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isInitializing } = useSiteAuth();
  const location = useLocation();

  if (isInitializing) {
    return (
      <div className="portal-guard-state">
        <p className="info-kicker">Portal access</p>
        <h1>Checking your Victoria&apos;s Place portal session.</h1>
        <p>Please wait while Bliss verifies the current site-user access.</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    const redirectTo = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={`/sign-in?redirect=${encodeURIComponent(redirectTo)}`} replace />;
  }

  return <>{children}</>;
}
